export enum AgentAvatarState {
    IDLE = "idle",
    LISTENING = "listening",
    THINKING = "thinking",
    SEARCHING = "searching",
    WORKING = "working",
    WRITING = "writing",
    WAITING = "waiting",
    NOTIFYING = "notifying",
    BLOCKED = "blocked",
    ERROR = "error",
    DONE = "done",
    CELEBRATE = "celebrate",
    SLEEPING = "sleeping",
    OFFLINE = "offline"
}
